<main class="container" style="display: flex; justify-content: center; align-items: center; text-align: center;">
    <nz-result nzStatus="warning" nzTitle="You does not have access to the application, please contact site administrator.">
       
      </nz-result>
</main>